/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchoolClass } from '../../models/school-class';

export interface GetSchoolClass$Params {
  schoolId: string;
  id: string;
}

export function getSchoolClass(http: HttpClient, rootUrl: string, params: GetSchoolClass$Params, context?: HttpContext): Observable<StrictHttpResponse<SchoolClass>> {
  const rb = new RequestBuilder(rootUrl, getSchoolClass.PATH, 'get');
  if (params) {
    rb.path('schoolId', params.schoolId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchoolClass>;
    })
  );
}

getSchoolClass.PATH = '/school/{schoolId}/classes/{id}';
